let registration: Promise<ServiceWorkerRegistration> | null = null;

/** A broken or unavailable worker must never leave installation and logout pending forever. */
export const withDeadline = <T,>(promise: Promise<T>, message: string, milliseconds = 10_000): Promise<T> =>
  new Promise((resolve, reject) => {
    const timer = window.setTimeout(() => reject(new Error(message)), milliseconds);
    promise.then(
      (value) => { window.clearTimeout(timer); resolve(value); },
      (error: unknown) => { window.clearTimeout(timer); reject(error); },
    );
  });

export const registerStaffWorker = (): Promise<ServiceWorkerRegistration> => {
  if (!registration) {
    registration = withDeadline(
      (async () => {
        const previous = await navigator.serviceWorker.getRegistration?.('/');
        if (!navigator.onLine && previous?.active) return previous;
        try { await navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }); }
        catch (error) { if (previous?.active) return previous; throw error; }
        return navigator.serviceWorker.ready;
      })(),
      'Não foi possível preparar a app neste dispositivo. Verifique a ligação e tente novamente.',
    ).catch((error: unknown) => { registration = null; throw error; });
  }
  return registration;
};
